module.exports = __webpack_public_path__ + "img/payment-stripe.1c2dab66.svg";